export const FILL_DETAILS = 'FILL_DETAILS';
export const FILL_STATUS_LIST = 'FILL_STATUS_LIST';
export const FILL_CURRENT_CALL_DETAILS = 'FILL_CURRENT_CALL_DETAILS';
export const FILL_SURVEY_INPUTS_LIST = 'FILL_SURVEY_INPUTS_LIST';
export const FILL_SURVEY_LIST = 'FILL_SURVEY_LIST';
export const FILL_CURRENT_CALL_SURVEY = 'FILL_CURRENT_CALL_SURVEY';
export const FILL_SURVEY_QUESTIONS = 'FILL_SURVEY_QUESTIONS';
export const FILL_LIST = 'FILL_LIST';
export const FILL_SURVEY_RESULTS_LIST = 'FILL_SURVEY_RESULTS_LIST';
export const FILL_SURVEY_ANSWERS = 'FILL_SURVEY_ANSWERS';
export const CLEAR_SURVEY_ANSWERS = 'CLEAR_SURVEY_ANSWERS';
